// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loadingState__oEZ4SegJiT{padding-bottom:8px}`, "",{"version":3,"sources":["webpack://./src/components/editorQuickRepliesDropdown/components/quickRepliesContent/components/templateList/templateList.module.scss"],"names":[],"mappings":"AAAA,0BACE,kBAAA","sourcesContent":[".loadingState {\n  padding-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingState": `loadingState__oEZ4SegJiT`
};
export default ___CSS_LOADER_EXPORT___;
